import { updateProfile } from "firebase/auth";
import { auth } from "../firebase";
import developerService from "./developer.service";

export async function saveDisplayName(displayName) {
  return updateProfile(auth.currentUser, { displayName: displayName.trim() });
}

export async function uploadProfileAvatar(dataUrl) {
  return developerService.uploadAvatar(dataUrl);
}

export async function refreshCurrentUser() {
  await auth.currentUser.reload();
  return auth.currentUser;
}

export async function deleteCurrentDeveloperAccount() {
  return developerService.deleteAccount();
}
